import { Collection, Discriminant } from '@features/product/components/Collection/Collection.types';
import { AvailabilityState } from '@features/product/typings';

// This function is used for the separate color from dropdown collection
// It returns only the color values that are part of the selected group / model in the dropdown.
export const filterSeparateColorDiscriminant = (
  collection: Collection,
  colorDiscriminant: Discriminant,
  selectedProductId?: number | null
) => {
  const dropdownDiscriminant = collection.discriminants.find(
    discriminant => discriminant.referenceId === null
  );

  if (!dropdownDiscriminant) return colorDiscriminant;

  // Get the selected value in the dropdown discriminant. On mobile get it based on the selected product id
  const selectedDropdownValue = dropdownDiscriminant?.values.find(value => {
    if (selectedProductId) {
      return value.products.some(product => product?.id === selectedProductId);
    }

    return value.isValueOfCurrentProduct;
  });

  const productIdsInCurrentGroup =
    selectedDropdownValue?.products.map(product => product?.id) ?? [];

  // Return the color discriminant and filter out the values which don't have a productId of the current group
  return {
    ...colorDiscriminant,
    values: colorDiscriminant.values.filter(value =>
      value.products.some(
        product =>
          product?.nullableAvailabilityState !== AvailabilityState.OutOfStock &&
          productIdsInCurrentGroup.includes(product?.id)
      )
    )
  };
};
